import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { HeaderAllMenuItemLink } from "scmp-app/components/header/header-oneline-menu-container/header-all-menu/common/header-mega-menu-item-link";

export const Title = styled.div`
  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  ${theme.breakpoints.up("mediumDesktop")} {
    font-size: 16px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;

  block-size: 32px;
  padding-block: 8px;
  padding-inline: 12px;

  column-gap: 16px;

  border-radius: 4px;

  background: rgba(69, 133, 255, 0.2);
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-flow: row;
  gap: 16px;
  ${HeaderAllMenuItemLink}:not(:last-child):after {
    content: " | ";

    margin-inline-start: 16px;
  }
`;
